export default "__VITE_ASSET__f37ddba1__"